import React, { useEffect, useState } from 'react';
import QRCode from 'qrcode';

/**
 * QRWidget — renders a QR code for any URL/text.
 *
 * Props:
 *   value    {string}  The URL or text to encode
 *   size     {number}  Pixel width/height of the QR image (default 120)
 *   label    {string}  Optional caption below the QR
 *   dark     {string}  QR dot color (default #0a1628)
 *   light    {string}  Background color (default #ffffff)
 *   style    {object}  Outer container style overrides
 */
export default function QRWidget({
  value,
  size = 120,
  label,
  dark = '#0a1628',
  light = '#ffffff',
  style,
}) {
  const [dataUrl, setDataUrl] = useState('');

  useEffect(() => {
    if (!value) return;
    QRCode.toDataURL(value, {
      width: size * 2,   // render 2× then downscale for crispness
      margin: 1,
      color: { dark, light },
      errorCorrectionLevel: 'M',
    }).then(setDataUrl).catch(() => {});
  }, [value, size, dark, light]);

  if (!dataUrl) return null;

  return (
    <div style={{
      display: 'inline-flex', flexDirection: 'column', alignItems: 'center', gap: 6,
      ...style,
    }}>
      <img
        src={dataUrl}
        alt={label || 'QR Code'}
        width={size}
        height={size}
        style={{ borderRadius: 8, display: 'block', border: `1px solid #e2e8f0` }}
      />
      {label && (
        <span style={{
          fontSize: '0.68rem', fontWeight: 600, color: '#64748b',
          textAlign: 'center', maxWidth: size, lineHeight: 1.3,
        }}>
          {label}
        </span>
      )}
    </div>
  );
}
